import { post, get } from './common/axiosClient'
import { API_AUTH_URL } from './common/constants'

export async function acceptTerm(term) {
  try {
    await post(`${API_AUTH_URL}/termos/aceites`, term, {
      headers: { 'Content-Type': 'application/json' }
    })
  } catch (e) {
    console.error('acceptTerm failed:', e)
    throw e
  }
}

export async function getAcceptedTerms() {
  try {
    const terms = await get(`${API_AUTH_URL}/termos/aceites`, {
      headers: { 'Content-Type': 'application/json' }
    })
    return terms
  } catch (e) {
    console.error('getAcceptedTerms failed:', e)
    throw e
  }
}

export async function getTerms() {
  try {
    const terms = await get(`${API_AUTH_URL}/termos`, {
      headers: { 'Content-Type': 'application/json' }
    })
    return terms
  } catch (e) {
    console.error('getTerms failed:', e)
    throw e
  }
}
